var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 54,
    viewBox: "0 0 47 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_4910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1274 7.12591C32.7958 3.79432 28.3644 1.96356 23.6549 1.96356C18.9389 1.96356 14.5141 3.79432 11.1825 7.12591C7.8509 10.4575 6.01367 14.8888 6.01367 19.5983C6.01367 29.1273 15.0251 37.0585 19.8705 41.3151C20.5433 41.9103 21.119 42.4214 21.5848 42.8483C22.167 43.3917 22.911 43.6634 23.6549 43.6634C24.3989 43.6634 25.1428 43.3917 25.7186 42.8483C26.1843 42.4214 26.7666 41.9103 27.4394 41.3151C32.2782 37.0585 41.2897 29.1273 41.2897 19.5983C41.2897 14.8888 39.459 10.4575 36.1274 7.12591Z",
    fill: "#0A6543",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4324 18.1398L21.3271 11.5727C20.9639 11.4052 20.5328 11.5614 20.3636 11.9225L17.4321 18.1984C17.3507 18.3723 17.3422 18.5716 17.408 18.7518C17.4739 18.932 17.6084 19.0791 17.7825 19.1604L19.9495 20.1693L19.1984 21.7778C19.117 21.9516 19.1085 22.1509 19.1743 22.3312C19.2402 22.5114 19.3746 22.6584 19.5488 22.7397L20.8714 23.3555L19.1474 27.0471H17.0045V25.4773C17.0045 25.0771 16.6803 24.7534 16.2796 24.7534C15.8789 24.7534 15.5547 25.0771 15.5547 25.4773V30.0631C15.5547 30.4631 15.8789 30.7869 16.2796 30.7869C16.6803 30.7869 17.0045 30.4631 17.0045 30.0631V28.4946H19.609C19.8907 28.4946 20.147 28.3313 20.2659 28.0769L22.1855 23.9671L23.5039 24.581C23.6031 24.627 23.7072 24.6489 23.8098 24.6489C24.0831 24.6489 24.3443 24.494 24.4675 24.2311L25.2186 22.6226L29.4569 24.5958C29.5559 24.6418 29.6601 24.6637 29.7627 24.6637C30.0359 24.6637 30.2972 24.5089 30.4204 24.246L30.5327 24.0053L32.307 24.8312C32.406 24.8771 32.5102 24.899 32.6128 24.899C32.886 24.899 33.1473 24.7443 33.2705 24.4813L34.9454 20.8949C35.1146 20.5323 34.9575 20.1019 34.595 19.933L34.3296 19.8094L35.3468 19.4848C35.6307 19.3944 35.8303 19.1392 35.8494 18.8416C35.8686 18.5441 35.7029 18.2655 35.4324 18.1398ZM33.1395 18.6698L31.6975 19.13L20.937 14.12L21.371 13.1905L33.1395 18.6698ZM31.1459 22.6937L32.045 20.7674C32.0879 20.6798 32.1615 20.4435 32.2943 20.4587L33.3249 20.9387L32.2631 23.2133L31.1459 22.6937Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_4910",
    x: 0.513672,
    y: 0.463562,
    width: 46.2759,
    height: 52.6999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4910"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4910",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiCameraIcon);
export default __webpack_public_path__ + "static/media/aiCameraIcon.721bbf58a650f259df471181897174f3.svg";
export { ForwardRef as ReactComponent };